import { FC } from "react";

import { Typography } from "@mui/material";

import { Translate } from "@/components/Application/Translate";

interface Props {
	translationString: string;
	ribbonText: string;
    ribbonColor: "grey" | "darkorange" | "red" | "green";
}

const styles = {
	ribbon: {
        marginTop: "-15.5px",
		zIndex: 3,
		font: "15px Sans-Serif",
		textTransform: "uppercase",
		textAlign: "center",
		textShadow: "rgba(238, 232, 232, 0.5) 0px .4px 0px",
		transform: "rotate(-45deg)",
		WebkitTransform: "rotate(-45deg)",
		MsTransform: "rotate(45deg)",
		OTransform: "rotate(45deg)",
		position: "relative",
		padding: "1px 0",
		left: -26,
		top: 4,
		width: 62,
		color: "#f3f2ef",
		backgroundColor: "#6e8900",
		WebkitBoxShadow: "0px 0px 3px rgba(0, 0, 0, 0.3)",
		MozBoxShadow: "0px 0px 3px rgba(0, 0, 0, 0.3)",
		boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.3)",
		"&:before, &:after": {
			content: '""',
			borderTop: "3px solid grey",
			borderLeft: "3px solid transparent",
			borderRight: "3px solid transparent",
			position: "absolute",
			bottom: "-3px",
		},
		"&:before": {
			left: 0,
		},
		"&:after": {
			right: 0,
		},
	},
};

const Ribbon: FC<Props> = (props: Props) => {
	const { translationString, ribbonText, ribbonColor } = props;

	return (
		<Typography sx={ { ...styles.ribbon, backgroundColor: ribbonColor }}>
			<Typography fontSize={9}>
				<Translate String={translationString}>{ribbonText}</Translate>
			</Typography>
		</Typography>
	);
};

export default Ribbon;
